import { post } from '@/utils/request';
import { MAP_SITE_URL } from '@/constants';
import { CaptchParams } from '@/types';

const {API_APIJ_URL,UPLOAD_URL} = MAP_SITE_URL;

interface QiBaoRecoveredParams extends CaptchParams {
  gameId: number;
  serverId: number;
  role: string;
  stolenTime: string;
  stolenItemInfo: string;
  stolenItemCode: string;
  askAccount?: string;
}

export const submitQiBaoRecovered = (params: QiBaoRecoveredParams) => {
  return post(`${API_APIJ_URL}/wegame/qiBaoItemsRecovered/create`, params);
};

interface UnsealApplicationParams extends CaptchParams {
  gameId: number;
  serverId: number;
  role: string;
  note: string;
  askAccount?: string;
}

export const submitUnsealApplication = (params: UnsealApplicationParams) => {
  return post(`${API_APIJ_URL}/wegame/resume/create`, params);
};

interface Equipment {
  equipmentName?: string;
  equipmentLevel?: number;
  equipmentProperty?: string;
}

interface Jewelry {
  necklaceName?: string;
  necklaceProperty?: string;
  jadeName?: string;
  jadeProperty?: string;
  braceletName?: string;
  braceletProperty?: string;
}

interface Pet {
  petName?: string;
  petLevel?: number;
  petWuxue?: number;
  petTech?: string;
}

interface StolenItems {
  equipmentMemo?: string;
  equipment?: Equipment[];
  jewelryMemo?: string;
  jewelry?: Jewelry;
  petMemo?: string;
  otherStolenItem?: string;
  pet?: Pet[];
}

interface CreateRecovered extends CaptchParams {
  gameId: number;
  serverId: number;
  role: string;
  stolenTime: string;
  stolenReasonsTypeId: number[];
  stolenItems: StolenItems;
  stolenReasons?: string;
}

export const createItemsRecovered = (params: CreateRecovered) => {
  return post(`${API_APIJ_URL}/wegame/itemsRecovered/create`, params);
};
// 附件上传


export const KfUploadFile = async (params: any) => {
  // return post(`http://upload.gyyx.cn/upload/community/file`, params);
  const response = await fetch(`${UPLOAD_URL}/upload/community/file`, {  
    method: 'POST',  
    body: params,
    credentials: 'include'
  });
  return await response.json()
};